import ApiConfig from "../api/config/api-config";
import {DateTime} from "luxon";
import {
    SubscriptionLogsApi,
    SubscriptionsApi,
    SubscriptionsController$SubscriptionJson,
    SubscriptionsController$SubscriptionListJson
} from "../api/generated/herds-licensing";

export type Subscription = SubscriptionsController$SubscriptionJson & {
    cancelledAt: DateTime;
    expiresAt: DateTime;
    validFrom: DateTime;
    isExpired: boolean;
};

export interface ISubscriptionService {
    active(): Promise<Subscription>;

    list(): Promise<SubscriptionsController$SubscriptionListJson[]>
    subscribe(breederId: string, duration: number): Promise<void>;
    unsubscribe(breederId: string): Promise<void>;

    history(breederId: string): Promise<string[]>;
}

const convertSubscription = (item: SubscriptionsController$SubscriptionJson): Subscription => ({
    ...item,
    validFrom: DateTime.fromISO(item.validFrom),
    expiresAt: DateTime.fromISO(item.expiresAt),
    cancelledAt: DateTime.fromISO(item.cancelledAt),
    isExpired: DateTime.fromISO(item.expiresAt) < DateTime.now(),
});

class SubscriptionServiceImpl implements ISubscriptionService {
    constructor(
        private readonly subscriptionApi: SubscriptionsApi,
        private readonly logsApi: SubscriptionLogsApi) {
    }

    async list(): Promise<SubscriptionsController$SubscriptionListJson[]> {
        const items = (await this.subscriptionApi.listAll()).items
        return items.map(item => ({
            ...item,
            subscription: convertSubscription(item.subscription),
        }));
    }

    async subscribe(breederId: string, duration: number): Promise<void> {
        await this.subscriptionApi.subscribe(breederId, {duration});
    }

    async unsubscribe(breederId: string): Promise<void> {
        await this.subscriptionApi.unsubscribe(breederId);
    }

    async active(): Promise<Subscription> {
        return convertSubscription((await this.subscriptionApi.get()).item);
    }

    async history(breederId: string): Promise<string[]> {
        return (await this.logsApi.history(breederId)).items;
    }
}

const subscriptionsApi = new SubscriptionsApi(new ApiConfig());
const subscriptionLogsApi = new SubscriptionLogsApi(new ApiConfig());
export const SubscriptionService: ISubscriptionService = new SubscriptionServiceImpl(subscriptionsApi, subscriptionLogsApi);